module.exports = __webpack_public_path__ + "static/media/ness_0.b15fca77.png";